import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'

import { applyJobV2Api } from '@core/app/api/applyJobV2Api'
import { authApi } from '@core/app/api/authApi'
import { calendarApi } from '@core/app/api/calendarApi'
import { contactsApi } from '@core/app/api/contactsApi'
import { filePreviewApi } from '@core/app/api/filePreviewApi'
import { globalApi } from '@core/app/api/globalApi'
import { loggedWorkApi } from '@core/app/api/loggedWorkApi'
import { logworkApi } from '@core/app/api/logworkApi'
import { paycheckApi } from '@core/app/api/paycheckApi'
import { postsApi } from '@core/app/api/postsApi'
import { profileApi } from '@core/app/api/profileApi'
import { requestsApi } from '@core/app/api/requestsApi'
import { settingsApi } from '@core/app/api/settingsApi'
import { newProfileApi } from '@core/app/api/v2/newProfileApi'
import absenceReducer from '@core/app/slices/absence'
import authReducer from '@core/app/slices/auth'
import calendarReducer from '@core/app/slices/calendar'
import loggedWorkReducer from '@core/app/slices/logged-work'
import logworkReducer from '@core/app/slices/logwork'
import profileReducer from '@core/app/slices/profile'
import payslipsReducer from '@core/app/slices/v2/payslips'
import { default as requestsReducer, default as simpleFilterReducer } from '@core/app/slices/requests'
import newProfileReducer from '@core/app/slices/v2/newProfile'

import { absenceApi } from '../api/absenceApi'
import { employeeApi } from '../api/employeeApi'
import { payslipsApi } from '../api/v2/payslipsApi'

const store = configureStore({
    reducer: {
        auth: authReducer,
        profile: profileReducer,
        payslips: payslipsReducer,
        logwork: logworkReducer,
        requests: requestsReducer,
        absence: absenceReducer,
        loggedWork: loggedWorkReducer,
        simpleFilter: simpleFilterReducer,
        calendar: calendarReducer,
        newProfile: newProfileReducer,
        [authApi.reducerPath]: authApi.reducer,
        [postsApi.reducerPath]: postsApi.reducer,
        [profileApi.reducerPath]: profileApi.reducer,
        [globalApi.reducerPath]: globalApi.reducer,
        [settingsApi.reducerPath]: settingsApi.reducer,
        [contactsApi.reducerPath]: contactsApi.reducer,
        [logworkApi.reducerPath]: logworkApi.reducer,
        [requestsApi.reducerPath]: requestsApi.reducer,
        [employeeApi.reducerPath]: employeeApi.reducer,
        [absenceApi.reducerPath]: absenceApi.reducer,
        [calendarApi.reducerPath]: calendarApi.reducer,
        [loggedWorkApi.reducerPath]: loggedWorkApi.reducer,
        [applyJobV2Api.reducerPath]: applyJobV2Api.reducer,
        [paycheckApi.reducerPath]: paycheckApi.reducer,
        [newProfileApi.reducerPath]: newProfileApi.reducer,
        [filePreviewApi.reducerPath]: filePreviewApi.reducer,
        [payslipsApi.reducerPath]: payslipsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            authApi.middleware,
            postsApi.middleware,
            profileApi.middleware,
            globalApi.middleware,
            settingsApi.middleware,
            contactsApi.middleware,
            logworkApi.middleware,
            requestsApi.middleware,
            calendarApi.middleware,
            employeeApi.middleware,
            absenceApi.middleware,
            loggedWorkApi.middleware,
            applyJobV2Api.middleware,
            paycheckApi.middleware,
            newProfileApi.middleware,
            filePreviewApi.middleware,
            payslipsApi.middleware
        ),
})

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
